<template>
  <div style="padding: 8px;">
    <div style="display: flex;align-items: center;">
      <div style="flex:1;">
        <el-tabs v-model="activeTab" @tab-click="handleClick">
          <el-tab-pane :label="$t('driver.vehiScoreCompare')" name="compare"></el-tab-pane>
          <el-tab-pane :label="$t('driver.vehiScoreDetail')" name="detail"></el-tab-pane>
        </el-tabs>
      </div>

    </div>
    <div v-show="activeTab == 'compare'" style="height:100%;width:100%">
      <!-- <div id="compareCharts" style="width:100%;height:275px"></div> -->
      <ScoreChart :dataList="dataList" :_loading="initLoading"></ScoreChart>
    </div>
    <div v-show="activeTab == 'detail'">
      <ScoreDetail :size="size" :selectedVehicles="selectedVehicles" :initDataList="dataList" :initTotal="total"
        :_loading="initLoading"></ScoreDetail>

    </div>
  </div>
</template>
<script>
import quickQuery from '../../statistics/components/generalOrQuickQuery.vue'
import { mapState } from 'vuex'
import ScoreChart from './scoreChart.vue'
import ScoreDetail from '@/views/driver/drivingScores/scoreDetail'
export default {
     name:"drivingScores",
  components: {
    quickQuery,
    ScoreChart,
    ScoreDetail
  },
  data() {
 
    return {
      initLoading: false,
      dataList: [],
      total: 0,
      vehicles: undefined,
      activeTab: "compare",
      searchTime: [new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000), new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)]
    }
  },
  computed: {
    ...mapState({
      operator: (state) => state.user.operator,
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
      appVehicles: state => state.app.vehicles,
    }),
    size() {
      return this.$store.getters.size
    },
    operator() {
      return this.$store.getters.operator
    },
  },
  watch: {

  },

  methods: {
    getSelectedVehicles() {
      this.vehicles = "";
      for (let k = 0; k < this.selectedVehicles.length; k++) {
        if (this.selectedVehicles[k].treeLevel == 5) {
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0, this.vehicles.length - 1);
    },
    getList() {
      this.vehicles = this.getSelectedVehicles();
      this.initLoading = true;
      this.$api.scoreInfo({
        vehicles: this.vehicles,
        beginDate: this.searchTime != null && this.searchTime[0] != undefined
          ? this.format(this.searchTime[0], "yyyy-MM-dd")
          : "",
        endDate: this.searchTime != null && this.searchTime[1] != undefined
          ? this.format(this.searchTime[1], "yyyy-MM-dd")
          : "",
        OperatorID: this.operator.OperatorId + "",//1668
        // OperatorID: 1668 + "",
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.dataList = res.data;
            this.total = res.count;

            this.initLoading = false;
          }
        })
        .catch((e) => {
          this.initLoading = false;
        })
    },
    // tab点击事件
    handleClick() {
      this.$nextTick(function () {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent);
      });
    },
    format(datetime, format) {
      var o = {
        "M+": datetime.getMonth() + 1, //month
        "d+": datetime.getDate(), //day
        "h+": datetime.getHours(), //hour
        "m+": datetime.getMinutes(), //minute
        "s+": datetime.getSeconds(), //second
        "q+": Math.floor((datetime.getMonth() + 3) / 3), //quarter
        S: datetime.getMilliseconds(), //millisecond
      };

      if (/(y+)/.test(format)) {
        format = format.replace(
          /(y+)/.exec(format)[0],
          (datetime.getFullYear() + "").substring(4 - /(y+)/.exec(format)[0].length)
        );
      }

      for (var k in o) {
        // console.log(o[k]);
        if (new RegExp("(" + k + ")").test(format)) {
          let item = eval("/(" + k + ")/.exec(format)[0]")
          format = format.replace(
            item,
            item.length == 1 ? o[k] : ("00" + o[k]).substring(("" + o[k]).length)
          );
          // console.log(format,"0.0");
        }
      }
      return format;
    },
  },
  mounted() {
    this.getList();
  }
}
</script>

<style lang="scss" scoped>
.page_container_a {
  margin-top: 10px;

  ::v-deep .el-table tr {
    background: rgb(244, 248, 255);
  }

  ::v-deep .el-table {
    background: rgb(244, 248, 255);
  }

  ::v-deep .el-table td {
    background: rgb(244, 248, 255);
  }
}

.el-divider--horizontal {
  margin-top: 0 !important;
}

::v-deep.el-tabs__header {
  margin: 0 !important;
}
</style>